import ScrollMagic from 'scrollmagic';

export const controller = new ScrollMagic.Controller();

export const createScene = (...args) => new ScrollMagic.Scene(...args);
